import {
  daoScopeListGet,
  daoScopePost,
  daoScopePatch,
  daoScopeApproversGet,
  daoScopeApproversPut,
  daoScopeApproversDelete
} from 'dao/scopemanagement-dao';

export const SCOPEMANAGEMENT_SCOPE_REQUEST_GET = 'SCOPEMANAGEMENT_SCOPE_REQUEST_GET';
export const SCOPEMANAGEMENT_SCOPE_REQUEST_GET_SUCCESS = 'SCOPEMANAGEMENT_SCOPE_REQUEST_GET_SUCCESS';
export const SCOPEMANAGEMENT_SCOPE_REQUEST_GET_FAILURE = 'SCOPEMANAGEMENT_SCOPE_REQUEST_GET_FAILURE';

export const SCOPEMANAGEMENT_SCOPE_POST = 'SCOPEMANAGEMENT_SCOPE_POST';
export const SCOPEMANAGEMENT_SCOPE_POST_SUCCESS = 'SCOPEMANAGEMENT_SCOPE_POST_SUCCESS';
export const SCOPEMANAGEMENT_SCOPE_POST_FAILURE = 'SCOPEMANAGEMENT_SCOPE_POST_FAILURE';

export const SCOPEMANAGEMENT_SCOPE_PATCH = 'SCOPEMANAGEMENT_SCOPE_PATCH';
export const SCOPEMANAGEMENT_SCOPE_PATCH_SUCCESS = 'SCOPEMANAGEMENT_SCOPE_PATCH_SUCCESS';
export const SCOPEMANAGEMENT_SCOPE_PATCH_FAILURE = 'SCOPEMANAGEMENT_SCOPE_PATCH_FAILURE';

export const SCOPEMANAGEMENT_SCOPE_APPROVERS_GET = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_GET';
export const SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_SUCCESS = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_SUCCESS';
export const SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_FAILURE = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_FAILURE';

export const SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT';
export const SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_SUCCESS = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_SUCCESS';
export const SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_FAILURE = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_FAILURE';

export const SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE';
export const SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_SUCCESS = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_SUCCESS';
export const SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_FAILURE = 'SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_FAILURE';


export const initialState = {
  data:{
    scopes: [],
  },
  isLoading: true,
  approversLoading: true,
};

export const scopeManagementIsLoading = (state) => state.scopeManagement.isLoading;
export const scopeManagementScopes = (state) => (state.scopeManagement && state.scopeManagement.data.scopes)? state.scopeManagement.data.scopes : [];
export const getApproversIsLoading = (state) => state.scopeManagement.approversLoading;
// ------------------------------------
// Actions
// ------------------------------------
export const scopeManagementScopesRequestGetSuccess = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_REQUEST_GET_SUCCESS,
  payload,
});

export const scopeManagementScopesRequestGetFailure = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_REQUEST_GET_FAILURE,
  payload,
});

export const scopeManagementScopesRequestGet = () => dispatch => {
  dispatch({
    type: SCOPEMANAGEMENT_SCOPE_REQUEST_GET,
  });

  return daoScopeListGet()
    .then(
      response => dispatch(scopeManagementScopesRequestGetSuccess(response.data)),
      ex => dispatch(scopeManagementScopesRequestGetFailure(ex)),
    );
};

export const scopeManagementPostSuccess = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_POST_SUCCESS,
  payload,
});

export const scopeManagementPostFailure = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_POST_FAILURE,
  payload,
});

export const scopeManagementPost = (payload) => dispatch => {
  dispatch({
    type: SCOPEMANAGEMENT_SCOPE_POST,
  });

  return daoScopePost(payload)
    .then(
      response => dispatch(scopeManagementPostSuccess(response.data)),
      ex => {
        dispatch(scopeManagementPostFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const scopeManagementScopePatchSuccess = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_PATCH_SUCCESS,
  payload,
});

export const scopeManagementScopePatchFailure = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_PATCH_FAILURE,
  payload,
});

export const scopeManagementScopePatch = (id,payload) => dispatch => {
  dispatch({
    type: SCOPEMANAGEMENT_SCOPE_PATCH,
  });

  return daoScopePatch(id,payload)
    .then(
      response => dispatch(scopeManagementScopePatchSuccess(response.data)),
      ex => {
        dispatch(scopeManagementScopePatchFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const scopeManagementScopeApproversGetSuccess = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_SUCCESS,
  payload,
});

export const scopeManagementScopeApproversGetFailure = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_FAILURE,
  payload,
});

export const scopeManagementScopeApproversGet = (scopeId) => dispatch => {
  dispatch({
    type: SCOPEMANAGEMENT_SCOPE_APPROVERS_GET,
  });
  return daoScopeApproversGet(scopeId)
    .then(
      response => dispatch(scopeManagementScopeApproversGetSuccess(response.data)),
      ex => dispatch(scopeManagementScopeApproversGetFailure(ex)),
    );
};

export const scopeManagementScopeApproversPutSuccess = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_SUCCESS,
  payload,
});

export const scopeManagementScopeApproversPutFailure = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_FAILURE,
  payload,
});

export const scopeManagementScopeApproversPut = (scopeId,approver,payload={}) => dispatch => {
  dispatch({
    type: SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT,
  });
  return daoScopeApproversPut(scopeId,approver,payload)
    .then(
      response => dispatch(scopeManagementScopeApproversPutSuccess(response.data)),
      ex => {
        dispatch(scopeManagementScopeApproversPutFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const scopeManagementScopeApproversDeleteSuccess = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_SUCCESS,
  payload,
});

export const scopeManagementScopeApproversDeleteFailure = (payload = {}) => ({
  type: SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_FAILURE,
  payload,
});

export const scopeManagementScopeApproversDelete = (scopeId,approver) => dispatch => {
  dispatch({
    type: SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE,
  });
  return daoScopeApproversDelete(scopeId,approver)
    .then(
      response => dispatch(scopeManagementScopeApproversDeleteSuccess(response.data)),
      ex => {
        dispatch(scopeManagementScopeApproversDeleteFailure(ex));
        return Promise.reject(ex);
      },
    );
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SCOPEMANAGEMENT_SCOPE_REQUEST_GET]: (state) => ({...state, isLoading: true}),
  [SCOPEMANAGEMENT_SCOPE_REQUEST_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          scopes:action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [SCOPEMANAGEMENT_SCOPE_REQUEST_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [SCOPEMANAGEMENT_SCOPE_POST]: (state) => ({...state, isLoading: true}),
  [SCOPEMANAGEMENT_SCOPE_POST_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          newScope: {
            ...action.payload
          },
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [SCOPEMANAGEMENT_SCOPE_POST_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [SCOPEMANAGEMENT_SCOPE_PATCH]: (state) => ({...state, isLoading: true}),
  [SCOPEMANAGEMENT_SCOPE_PATCH_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [SCOPEMANAGEMENT_SCOPE_PATCH_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [SCOPEMANAGEMENT_SCOPE_APPROVERS_GET]: (state) => ({...state, approversLoading: true}),
  [SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          approvers: action.payload,
        },
        approversLoading: false,
      };
    }
    return {...state, approversLoading: false};
  },
  [SCOPEMANAGEMENT_SCOPE_APPROVERS_GET_FAILURE]: (state) => ({
    ...state,
    approversLoading: false,
  }),

  [SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT]: (state) => ({...state, isLoading: true}),
  [SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          approvers: action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [SCOPEMANAGEMENT_SCOPE_APPROVERS_PUT_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE]: (state) => ({...state, isLoading: true}),
  [SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          approvers: action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [SCOPEMANAGEMENT_SCOPE_APPROVERS_DELETE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),
};

const scopesReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};


export default scopesReducer;
